import { tenantApi } from '@shared/api/tenantApi';
import { useAuthStore, normalizeAuthUser } from '@shared/stores/authStore';
import { resolveDomain } from '@shared/api/domainApi';
import type { AuthResponse } from '@shared/types/auth';

export async function loginStaff(email: string, password: string): Promise<void> {
  const auth = useAuthStore.getState();
  if (!auth.regionalApiUrl) {
    await resolveDomain(window.location.hostname);
  }

  const { data } = await tenantApi.post<AuthResponse>('/auth/login', {
    email: email.trim().toLowerCase(),
    password,
  });

  if (!data.success) {
    throw new Error('Login failed');
  }

  await auth.setAuth(data);
  if (data.user?.tenantId) {
    auth.setTenantId(data.user.tenantId);
  }
  const normalized = normalizeAuthUser(data.user);
  if (normalized?.tenantId) {
    auth.setTenantId(normalized.tenantId);
  }
}
